import { JsonpModule } from '@angular/http';
import { ResponseService } from './response.service';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/Rx';

@Injectable()
export class IpmiService {

  public serverStatus: ReplaySubject<Boolean> = new ReplaySubject(1);
  private ipmiData: ReplaySubject<any> = new ReplaySubject(1);

  constructor(
    private apiService: ApiService,
    private responseService: ResponseService
  ) { }

  /**
   * Pobranie stanu zasilania
   * 
   * @param {String} serviceId 
   * @returns {Promise<any>} 
   * @memberof IpmiService
   */
  public powerGet(serviceId: String): Promise<any> {
    return this.apiService.get(`/ipmi/${serviceId}/power_get`)
      .map(response => {
        const powerStatus = this.responseService.success(false, response, 'power_status');
        return powerStatus;
      }).toPromise();
  }

  /**
   * Włączenie lub wyłączenie serwera
   * 
   * @param {String} serviceId
   * @param {String} type 
   * @returns {Promise<any>} 
   * @memberof IpmiService
   */
  public powerOnOff(serviceId: String, type: String): Promise<any> {
    return this.apiService.get(`/ipmi/${serviceId}/power_${type}`)
      .toPromise();
  }

  public powerReset(serviceId: String): Promise<any> {
    return this.apiService.get(`/ipmi/${serviceId}/power_reset`)
      .toPromise();
  }

  public setServerStatus(status: Boolean): void {
    return this.serverStatus.next(status);
  }

  public getServerStatus(): ReplaySubject<Boolean> {
    return this.serverStatus;
  }

  public ipmiServer(serviceId: String): ReplaySubject<any> {
    this.apiService.get(`/ipmi/${serviceId}/server`).subscribe(
      (response) => {
        const ipmi = this.responseService.success(false, response, 'ipmi');
        this.ipmiData.next(ipmi);
      },
      (error) => {
        this.ipmiData = new ReplaySubject(1);
        this.responseService.error(error);
      }
    );
    return this.ipmiData;
  }

  public startNAT(nat_options: Object): ReplaySubject<any> {
    this.apiService.post(`/ipmi/${nat_options['id']}/start_nat`, nat_options).subscribe(
      (response) => {
        const ipmi = this.responseService.success(false, response);
        this.ipmiServer(nat_options['id']);
      },
      (error) => {
        this.responseService.error(error);
      }
    );

    return this.ipmiData;
  }

  public stopNAT(serviceId: String): ReplaySubject<any> {
    this.apiService.post(`/ipmi/${serviceId}/stop_nat`).subscribe(
      (response) => {
        this.responseService.success(false, response);
        this.ipmiServer(serviceId);
      },
      (error) => {
        this.responseService.error(error);
      }
    );
    return this.ipmiData;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ipmi.service.ts